/**
 * @binding {value: {list: 循环数据列表, id: 绑定数据id, index: 循环轮次}}
 * @return:
 */
const blurBottomFocus = (app, options) => {
  app.directive("blurBottomFocus", (el, binding) => {
    el.addEventListener("keydown", (e) => {
      if (e.keyCode === 13) {
        e.target.blur();
        if (binding.value.index + 1 < binding.value.list.length) {
          binding.value.list[binding.value.index + 1].focus();
        }
      }
    });
  });
};
export default blurBottomFocus;
